import { MOVE_OUTCOME, GROUP_OUTCOMES } from './actionTypes'

export const moveSummaryOutcome = (payLoad) => (
  { type: MOVE_OUTCOME, ...payLoad }
)

export const groupOutcomes = (outcomes) => (
  { type: GROUP_OUTCOMES, outcomes }
)
